const reportTypes = [
  { label: 'Korupsi & Gratifikasi', emoji: '🏛️' },
  { label: 'Penyalahgunaan Wewenang', emoji: '⚖️' },
  { label: 'Konflik Kepentingan', emoji: '🔄' },
  { label: 'Penggelapan Aset Negara', emoji: '📦' },
  { label: 'Suap & Pungli', emoji: '💰' },
  { label: 'Pemalsuan Dokumen', emoji: '📄' },
  { label: 'Pelanggaran Kode Etik', emoji: '📋' },
  { label: 'Kecurangan Pengadaan', emoji: '🛒' },
]

export default function JenisPelanggaranSection() {
  return (
    <section className="py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-blue-600 text-sm font-bold uppercase tracking-widest">Jenis Pelanggaran</span>
          <h2 className="mt-3 text-3xl font-extrabold text-slate-900">Apa yang Bisa Dilaporkan?</h2>
          <p className="mt-3 text-slate-500 max-w-xl mx-auto text-sm">
            Sistem kami menerima berbagai kategori laporan terkait pelanggaran di lingkungan pemerintahan.
          </p>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {reportTypes.map(type => (
            <div key={type.label} className="bg-white border border-slate-200 hover:border-blue-300 hover:shadow-md rounded-2xl p-5 text-center transition-all cursor-default group">
              <div className="text-3xl mb-3">{type.emoji}</div>
              <div className="text-sm font-semibold text-slate-700 group-hover:text-blue-700 leading-snug">{type.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
